<template lang="pug">
  v-container
    //- Dialogs
    v-dialog(v-model="dialog" persistent="" max-width="400")
      v-card
        v-card-title.headline ¿Desea agregar esta imagen?
        v-card-text
          v-img(contain max-height='150px' name='image', :src='selectedItem.link')
          v-text-field(v-model="title" label="Título" clearable)
          v-textarea(v-model="description" label="Descripción" clearable)
        v-card-actions
          v-spacer
          v-btn(color="secondary" text="" @click="dialog = false") Cancelar
          v-btn(color="secondary" :loading="uploadingImage" text="" @click="handleImageUpload(imageFile)") Aceptar
    v-dialog(v-model='confirmationDialog' width="300px" persistent)
      v-card.pa-2
        v-card-title.headline Eliminar multimedia
        v-card-text
          v-img(contain max-height='150px' name='image', :src='selectedItem.href')
        v-card-actions
          v-spacer
          v-btn.px-3(color='green darken-1', flat='', @click='confirmationDialog = false') No, Cancelar
          v-btn.px-3(color='red darken-1', flat :loading="deletingItem" @click='deleteItem') Si, eliminar
    //- No result
    noResults(v-if="multimedia.length === 0" title="No tienes multimedia" description='En la "Multimedia" puedes mostrar imagenes de tu tienda y tus articulos para los usuarios que te visiten.')
    //- Content
    template(v-if="multimedia.length > 0 || newItem == true")
      v-row.justify-end
        input.d-none(ref="file" type="file" accept="image/*" @change="handleImage")
      v-row.pr-4
        template(v-for="(i, index) in multimedia")
          v-col.d-flex.justify-center(:key="i" cols="12" xs="6" sm="6" md="4" lg="4" xl="3" style="position: relative")
            v-img.rounded-lg(height="200" width="200" :src="i.href").multimedia__img
            v-btn(absolute right small fab text @click='openDeleteModal(i)')
              v-icon(color="red") mdi-delete
</template>
<script>
  import Swal from 'sweetalert2'
  import * as firebase from 'firebase'
  import imageCompression from 'browser-image-compression'
  export default {
    components: {
      noResults: () => import('@/components/custom/NoResults.vue'),
    },
    props: {
      multimedia: {
        type: Array,
        default: function () {
          return []
        },
      },
      newItem: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        dialog: false,
        selectedItem: {
          link: '',
        },
        imageFile: '',
        imageRef: '',
        uploadingImage: false,
        confirmationDialog: false,
        deletingItem: false,
        title: '',
        description: '',
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      shop () {
        return this.$store.getters['shops/getCurrentItem'].id
      },
      user () {
        return this.$store.getters['shops/getCurrentItem'].ownerId
      },
    },
    watch: {
      newItem: function (newValue, oldValue) {
        // console.log('por aqui')
        if (newValue) {
          this.pickFile('file')
          this.$emit('addedMultimedia')
        }
      },
    },
    mounted () {
      if (this.newItem) {
        this.pickFile('file')
        this.$emit('addedMultimedia')
      }
    },
    methods: {
      pickFile (ref) {
        this.$refs[ref].click()
        this.imageRef = ref
      },
      uploadToServer (file) {
        const vm = this
        const storageRef = firebase.storage().ref()
        const imageId = firebase.database().ref().child(`users/${this.user}/shops/${this.shop}/multimedia`).push().key
        const metadata = {
          contentType: file.type,

          customMetadata: {
            targetType: file.type,
            targetId: imageId,
          },
        }
        // Push to child path.
        // [START oncomplete]
        storageRef.child(`users/${this.user}/shops/${this.shop}/multimedia/${imageId}`).put(file, metadata).then(function (snapshot) {
          snapshot.ref.getDownloadURL().then(function (url) {
            // console.log(url)
            vm.selectedItem.link = url
            vm.$store.dispatch('cms/createMultimedia', { id: imageId, title: vm.title, description: vm.description, url }).then(() => {
              vm.title = ''
              vm.description = ''
              vm.dialog = false
              vm.uploadingImage = false
            })
          })
        }).catch(function (error) {
          vm.uploadingImage = false
          console.error('Upload failed:', error)
        })
      },
      handleImage (event) {
        this.dialog = true
        this.imageFile = event.target.files[0]
        this.selectedItem.link = URL.createObjectURL(this.imageFile)
      },
      async handleImageUpload (file) {
        const vm = this
        vm.uploadingImage = true
        const imageFile = file
        // console.log('originalFile instanceof Blob', imageFile instanceof Blob) // true
        // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`)

        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 2000,
          useWebWorker: true,
          maxIteration: 15,
        }
        try {
          const compressedFile = await imageCompression(imageFile, options)
          // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob) // true
          // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`) // smaller than maxSizeMB
          if (imageFile.size > compressedFile.size) {
            // console.log('compressed is smaller')
            await vm.uploadToServer(compressedFile)
          } else {
            // console.log('original is smaller')
            await vm.uploadToServer(imageFile)
          } // if original is smaller
        } catch (error) {
          vm.uploadingImage = false
          // console.log(error)
        }
      },
      setImage (ref, image) {
        // console.log(ref)
        this.model.pictures[ref] = image
        // console.log(this.model)
        this.$forceUpdate()
      },
      openDeleteModal (item) {
        const vm = this
        vm.selectedItem = item
        Swal.fire({
          title: 'Eliminar imagen',
          text: '¿Deseas continuar?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2ca0a5',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.isConfirmed) {
            vm.deleteItem()
          }
        })
      },
      deleteItem () {
        const vm = this
        vm.deletingItem = true
        vm.$store.dispatch('cms/deleteMultimedia', { id: vm.selectedItem.id }).then(function () {
          vm.confirmationDialog = false
          vm.deletingItem = false
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .multimedia {
    &__img {
      position: relative;
      object-fit: cover;
    }

    &__delete-btn {
      position: absolute;
      right: 1%;
      top: 5%;
    }
  }
</style>
